module.exports = __webpack_public_path__ + "img/bg1.c68505c5.jpg";